<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>連絡先新規作成</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>連絡先名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="contact.contactName" class="form-control" autocomplete="off" placeholder="連絡先名（必須）" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ふりがな</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="80" v-model="contact.contactKana" class="form-control" autocomplete="off" placeholder="ふりがな（必須）" required>
              </div>
            </div>
          </div>
          <div class="form-group" v-for="(phoneNumber, index) in phoneNumbers" v-bind:key="`phoneNumber-${index}`">
            <div class="row">
              <div class="col-3">
                <label>番号{{ index  + 1 }}</label>
              </div>
              <div class="col-2">
                <select v-model="phoneNumber.type" class="form-control">
                  <option value="1" selected>内線</option>
                  <option value="2">外線</option>
                  <option value="3">ダイヤルイン</option>
                  <option value="4">FAX</option>
                </select>
              </div>
              <div class="col-6">
                <input type="text" pattern="[\d\-]*"  maxlength="16" v-model="phoneNumber.phoneNumber" class="form-control" placeholder="番号（必須）" required>
              </div>
              <div class="col-1">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="remove(index)" v-show="index !== 0">×</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-9">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="add" v-show="!isMaximum">番号を追加する</button>
              </div>
            </div>
          </div>
          <div class="form-group" v-for="(group, index) in groups" v-bind:key="`group-${index}`">
            <div class="row">
              <div class="col-3">
                <label>グループ{{ index  + 1 }}</label>
              </div>
              <div class="col-8">
                <select v-if="index==0" v-model="group.groupId" class="form-control" :required="required ? true : false">
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
                <select v-else v-model="group.groupId" class="form-control" required>
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
              </div>
              <div class="col-1">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="removeGroup(index)" v-show="index !== 0">×</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-9">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="addGroup" v-show="!isMaximumGroup">グループを追加する</button>
              </div>
            </div>
          </div>

          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      name: 'group',
      message: '',
      contact: {
        hospitalId: '',
        contactName: '',
        contactKana: ''
      },
      phoneNumbers: [
        {
          type: '1',
          phoneNumber: ''
        },
      ],
      groups: [{
        groupId: ''
      }],
      groupOptions: [],
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isMaximum: function () {
      return this.phoneNumbers.length === 5
    },
    isMaximumGroup: function () {
      return this.groups.length === 3
    },
    required: function () {
      return this.groups.length > 1
    }
  },
  beforeMount() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        var extraContactId = this.$route.params.extraContactId
        var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                    ? "/api/hierarchygroup/management/hierarchylist" 
                    : "/api/group/management/public/list"
        axios
          .post(url, {
            hospitalId: hospitalId,
            extraContactId: extraContactId,
            hierarchyNo: 2
          },{
            headers: this.headers(accessToken)
          })
          .then(response => {
            this.groupOptions = response.data.data.groups
            this.groupOptions.unshift({
              id : '',
              groupName : ''
            })
          })
          .catch(err => {
            throw err
          })
      }
    }).catch((err) => {
        this.message = err.message
    })
  },
  methods: {
    register() {
      var checkGroups = this.groups.filter((element, index, self) => 
                            self.findIndex(e =>  e.groupId === element.groupId) === index)
      if (checkGroups.length !== this.groups.length){
        this.message =  'グループが重複しています'
        return
      } else {
        this.message = ''
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          this.contact.hospitalId = hospitalId
          this.contact.extraContactId = this.$route.params.extraContactId
          axios.post("/api/contact/management/public/", {
              contact: this.contact,
              phoneNumbers: this.phoneNumbers,
              groups: this.groups,
              extraContactId: this.$store.getters.contact.id
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
    },
    add() {
      this.phoneNumbers.push(
        {
          type: "1",
          phoneNumber: ''
        }
      )
    },  
    remove(index) {
      this.phoneNumbers.splice(index, 1)
    },
    addGroup() {
      this.groups.push(
        {
          groupId: ''
        }
      )
    },  
    removeGroup(index) {
      this.groups.splice(index, 1)
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>